export default __webpack_public_path__ + "static/doodle-eyes-9e99acd3acbafea7b093bdf5c6bcc191.svg";